export class Overpackfilteroption {
    overpackCode:string;
    status:string;
    shipmentId:number;
    shipmentCode:string;
    countryName:string;
    overpackId:number;
    franchiseId:number;
    searchKey:string;
    countryId:number;
    showAll:boolean;
    shipmentDate:Date;
    excludeStatus:string;
}
